import { notification } from 'antd';
import html2canvas from 'html2canvas'
import { updateRelativeURIsToFullURLs } from '../../src/utils/stringOps'

export const generateClipboardContent = (isPortfolio,isEntity,baseURL) => {

    var finalElement = document.createElement('div');
    finalElement.setAttribute("Id", "divFinalClipboard")

    var style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = `
    .article-title {color: #000; font-size: 16pt; font-weight: bold; font-family: Arial; line-height: 1.15}
    .article-published {color: #000; font-size: 9pt; font-family: Arial; line-height: 1}
    .info-icon  {display: none}
    .article-author {color: #000; font-size: 9pt; font-family: Arial; line-height: 1}
    .grid-content-full, .grid-content-center, .content table, .grid-content-aside {color: #000; font-size: 9pt; font-family: Arial; line-height: 1}
    .content table th {padding: 0; vertical-align: top; align: left}
    .article-inBrief, .box-header {font-weight: bold}
    #divFinalPdf { .custom-checkbox label:after {height:15px; width:5px; left: 4px;}  .custom-checkbox input[type=\"checkbox\"]:checked ~ label::after { transform: rotate(-61deg) scale(1); }}
    `;
    finalElement.appendChild(style);

    var divArticleTitle = document.getElementsByClassName('article-title')[0].cloneNode(true);
    finalElement.appendChild(divArticleTitle);

    if (document.getElementsByClassName('article-published')[0] != null)
    {
        var divArticlePublished = document.getElementsByClassName('article-published')[0].cloneNode(true);
        finalElement.appendChild(divArticlePublished);
    }   
   
    var divContent

    if(isPortfolio)
    {
        divContent= document.getElementsByClassName('grid-content-center')[0].cloneNode(true)    
        divContent.querySelector('.article-inBrief').innerHTML = '<br/>' + divContent.querySelector('.article-inBrief').innerHTML + '<br/>'
    }    
    else
    {
        divContent= document.getElementsByClassName('grid-content-full')[0].cloneNode(true) 
        if (document.getElementsByClassName('article-author')[0] != null)
        {
            var divArticleAuthor = document.getElementsByClassName('article-author')[0].cloneNode(true)
            finalElement.appendChild(divArticleAuthor)
        }   
        if (divContent.querySelector('.article-inBrief') != null)
        {
            divContent.querySelector('.article-inBrief').innerHTML = '<br/>' + divContent.querySelector('.article-inBrief').innerHTML + '<br/>'
        }            
        if (!(isEntity)) 
        {            
            divContent.querySelector('.article-fullText').innerHTML = divContent.querySelector('.article-fullText').innerHTML + '<br/><br/>'
        }           
    }    

    if (!(isEntity)) 
    {
        divContent.querySelector('.article-tags').innerHTML = '<br/>' + divContent.querySelector('.article-tags').innerHTML 
    }
    
    divContent.innerHTML =  updateRelativeURIsToFullURLs(divContent.innerHTML, baseURL)   
    
    finalElement.appendChild(divContent)

    if(isPortfolio)
    {
        var divContentAside = document.getElementsByClassName('grid-content-aside')[0].cloneNode(true);   
        finalElement.appendChild(divContentAside);      
    }        
    return finalElement.innerHTML
}